module.exports = __webpack_public_path__ + "img/New PACI Flow - New-1.6d66f4dd.png";